import http from "./http_common";

class VitalService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => (key && payload[key])? key + "=" + payload[key]:'')
      .join("&");
  }

  VitalMasterlist(payload) {
    var queryString = this.queryString(payload);
    return http.get(`vitalMaster/list/filter?${queryString}`);
  }
  
  AddVitals(data) {
    return http.post(`patientVitals/BatchSave/`, data);  
  }

  updateVital(data){
    return http.put('/patientVitals/BatchUpdate',data);
  }

  getVitalsData(payload) {
    var queryString = this.queryString(payload);
    return http.get(`/patientVitals/list/recordedVitalDateTime?${queryString}`);
  }

  getAllVitalsData(payload){
    var queryString = this.queryString(payload);
    return http.get(`patientVitals/list/filter?${queryString}`);
  }

  getSpecificVitalData(payload){
    var queryString = this.queryString(payload);
    return http.get(`/patientVitals/list/filter?${queryString}`);
  }

  getPatientRecentVital(payload){
    return http.get(`/patientVitals/list/recentRecords/${payload.patientId}`)
  }

  getVitalForGraph(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/patientVitals/list/patientVitals?${queryString}`);
  }
}

export default new VitalService();
